export default __webpack_public_path__ + "assets/sounds/03b11d43f0f7146f7e5833f6a5bbf554.mp3";